import React, { useState } from 'react';
import C from '../colors';

export function OrderFormColumns({ children, preview }) {
  return (
    <div style={{
      padding: '10px 36px 32px',
      display: 'grid',
      gridTemplateColumns: 'minmax(0, 1.15fr) minmax(340px, .85fr)',
      gap: 36,
      flex: 1,
    }}>
      <div>{children}</div>
      {preview}
    </div>
  );
}

export function OrderFormGrid({ children, template = '1fr 1fr' }) {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: template, columnGap: 20 }}>
      {children}
    </div>
  );
}

export function OrderFormSection({ children }) {
  return (
    <div style={{
      fontFamily: C.mono, fontSize: 10, letterSpacing: 1.5,
      textTransform: 'uppercase', color: C.brand, fontWeight: 600,
      marginBottom: 6, marginTop: 18,
    }}>
      {children}
    </div>
  );
}

export function OrderFormRow({ label, caption, children, inline, last, required = false, optional = false }) {
  return (
    <div style={{
      padding: '11px 0',
      borderBottom: last ? 'none' : `1px solid ${C.hair}`,
      display: inline ? 'grid' : 'block',
      gridTemplateColumns: inline ? '1fr auto' : undefined,
      alignItems: inline ? 'center' : undefined,
      gap: 16,
    }}>
      <div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 14, fontWeight: 500, color: C.ink, marginBottom: 3 }}>
          <span>{label}</span>
          {required && <span style={{ color: '#C2412E', fontSize: 13, fontWeight: 700 }}>*</span>}
          {optional && <span style={{ fontSize: 11, color: C.ink3, fontWeight: 400 }}>选填</span>}
        </div>
        {caption && <div style={{ fontSize: 12.5, color: C.ink3, lineHeight: 1.5, maxWidth: 520 }}>{caption}</div>}
      </div>
      {!inline && <div style={{ marginTop: 7 }}>{children}</div>}
      {inline && <div>{children}</div>}
    </div>
  );
}

export function OrderToggle({ value, onChange, disabled, testId, label }) {
  return (
    <button
      type="button"
      data-testid={testId}
      aria-label={label}
      aria-pressed={value}
      onClick={() => !disabled && onChange(!value)}
      disabled={disabled}
      style={{
        width: 44, height: 24, borderRadius: 12,
        border: 'none', padding: 2,
        background: value ? C.brand : C.hair2,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.4 : 1,
        transition: 'background .2s',
        display: 'flex', alignItems: 'center',
        justifyContent: value ? 'flex-end' : 'flex-start',
      }}
    >
      <div style={{ width: 20, height: 20, borderRadius: 10, background: '#fff', boxShadow: '0 1px 3px rgba(0,0,0,.2)' }}/>
    </button>
  );
}

export function OrderTextInput({ name, value, onChange, onBlur, placeholder, multiline, rows }) {
  const [focused, setFocused] = useState(false);
  const style = {
    width: '100%', boxSizing: 'border-box',
    padding: '9px 12px',
    border: `1px solid ${focused ? C.brand : C.hair2}`,
    borderRadius: 6, outline: 'none',
    fontFamily: C.sans, fontSize: 14, color: C.ink,
    background: '#fff', transition: 'border-color .15s',
    resize: multiline ? 'vertical' : undefined,
    minHeight: multiline ? 72 : undefined,
  };
  const handleBlur = event => {
    setFocused(false);
    onBlur?.(event);
  };

  return multiline
    ? <textarea name={name} value={value || ''} onChange={onChange} onBlur={handleBlur} placeholder={placeholder}
        rows={rows || 2} onFocus={() => setFocused(true)} style={style}/>
    : <input name={name} value={value || ''} onChange={onChange} onBlur={handleBlur} placeholder={placeholder}
        onFocus={() => setFocused(true)} style={style}/>;
}

export function OrderNumberInput({ name, value, onChange, onBlur, prefix, suffix, disabled, error, helperText }) {
  const [focused, setFocused] = useState(false);
  const handleBlur = event => {
    setFocused(false);
    onBlur?.(event);
  };

  return (
    <div>
      <div style={{
        display: 'inline-flex', alignItems: 'center',
        border: `1px solid ${error ? '#e88c7c' : focused ? C.brand : C.hair2}`,
        borderRadius: 6, padding: '0 12px',
        background: disabled ? C.paper2 : '#fff',
        opacity: disabled ? 0.6 : 1,
        transition: 'border-color .15s', width: 220,
      }}>
        {prefix && <span style={{ fontSize: 14, color: C.ink3, marginRight: 4 }}>{prefix}</span>}
        <input
          type="number"
          name={name}
          value={value ?? ''}
          disabled={disabled}
          onChange={onChange}
          onBlur={handleBlur}
          onFocus={() => setFocused(true)}
          style={{ flex: 1, border: 'none', outline: 'none', padding: '9px 0', fontSize: 14, fontFamily: C.sans, background: 'transparent', color: C.ink, fontVariantNumeric: 'tabular-nums' }}
        />
        {suffix && <span style={{ fontSize: 14, color: C.ink3, marginLeft: 4 }}>{suffix}</span>}
      </div>
      {error && helperText && <div style={{ fontSize: 12, color: '#c2412e', marginTop: 4 }}>{helperText}</div>}
      {!error && helperText && <div style={{ fontSize: 12, color: C.ink3, marginTop: 4 }}>{helperText}</div>}
    </div>
  );
}
